import Axios from 'axios';
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

function FixtureAPITemplate({id, type}) {

    const [fixture, setFixture] = useState()
    const [isLoading, setIsLoading] = useState(true)

    const [timeFormatted, setTimeFormatted] = useState()
    const [dateFormatted, setDateFormatted] = useState()


    useEffect(() => {

        async function fetchSingleFixture() {
            setIsLoading(true)
            try {
                const response = await Axios({
                    "method":"GET",
                    "url":"https://api-football-v1.p.rapidapi.com/v2/fixtures/id/" + id,
                    "headers":{
                    "content-type":"application/octet-stream",
                    "x-rapidapi-host":"api-football-v1.p.rapidapi.com",
                    "x-rapidapi-key":"4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45",
                    "useQueryString":true
                    },"params":{
                    "timezone":"Europe/London"
                    }
                })
                setFixture(response.data.api.fixtures[0])
            } catch (error) {
                console.log(error)
            }
            setIsLoading(false)
        }
        fetchSingleFixture()

    }, [id])

    useEffect(() => {
        if (fixture) {
            const date = new Date(fixture.event_date);
    
            let minutes = date.getMinutes()
            let day = date.getDate();
            let month = date.getMonth()+1;
            let year = date.getFullYear();
        
            if (day < 10) {
                day = `0${day}`
            } else {
                day = day 
            }
            if (month < 10) {
                month = `0${month}`
            } else {
                month = month
            }
            if (minutes < 10) {
                minutes = `0${minutes}`
            }
            const dateFormatted = `${day}/${month}/${year}`
            const timeFormatted = date.getHours() + ":" + minutes
            setTimeFormatted(timeFormatted)
            setDateFormatted(dateFormatted)
        }
    }, fixture)



    if (isLoading || !fixture) return <p>Laster</p>

    return (
        <div className="card card-body py-2 mb-1 bg-white" style={{fontSize: "0.8rem"}}>

            <div className="row">
                
                <div className="col-7">   
                    <Link to={type === "small" ? `/live-fixtures/single/${fixture.fixture_id}` : `/live-fixtures/${fixture.fixture_id}`}>           
                        <img src={fixture.homeTeam.logo} className="img-fluid teamLogo" /> {fixture.homeTeam.team_name}    
                    </Link>      
                </div>
                <div className="col-3">
                    {fixture.statusShort === "FT" ? <small>FT</small> : fixture.statusShort === "NS" ? <small>{dateFormatted}</small> : ""}
                </div>
                <div className="col-2 text-right">
                    <Link to={type === "small" ? `/live-fixtures/single/${fixture.fixture_id}` : `/live-fixtures/${fixture.fixture_id}`}>{fixture.goalsHomeTeam}</Link>
                </div>



                <div className="col-7">
                    <Link to={type === "small" ? `/live-fixtures/single/${fixture.fixture_id}` : `/live-fixtures/${fixture.fixture_id}`}>
                        <img src={fixture.awayTeam.logo} className="img-fluid teamLogo" /> {fixture.awayTeam.team_name} 
                    </Link>
                </div>
                <div className="col-3">
                        {fixture.statusShort === "FT" ? <small>{dateFormatted}</small> : fixture.statusShort === "NS" ? <small>{timeFormatted}</small> :
                        <>
                            {fixture.elapsed && fixture.elapsed > 0 && fixture.elapsed <= 90 && fixture.statusShort !== "FT" ?
                            <span className="text-success">{fixture.elapsed + "'"} <i className="fas fa-circle-notch fa-spin"></i></span>
                            : "FT"
                            }
                        </>
                    }
                </div>
                <div className="col-2 text-right">
                    <Link to={type === "small" ? `/live-fixtures/single/${fixture.fixture_id}` : `/live-fixtures/${fixture.fixture_id}`}>   {fixture.goalsAwayTeam}</Link>
                </div>

            </div>
        </div>
    )

}
export default FixtureAPITemplate